import React from "react";
import { CommandBarButton, DirectionalHint, TooltipHost } from "@fluentui/react";
import { isNullUndefined, isNullUndefinedOrEmpty } from "./Helpers";
import { missingPonderador } from "./ponderadores";

export const __onRenderOverflowItem = (item) => {
    return (
      <TooltipHost content={item.title} directionalHint={DirectionalHint.rightCenter}>
        <CommandBarButton
          role="menuitem"
          aria-label={item.name}
          styles={{ root: { padding: '10px' } }}
          iconProps={{ iconName: item.icon }}
          onClick={item.onClick}
        />
      </TooltipHost>
    );
};

export const __onRenderOverflowButton = (overflowItems) => {
    return (
      <TooltipHost content="More items" directionalHint={DirectionalHint.rightCenter}>
        <CommandBarButton
          role="menuitem"
          aria-label="More items"
          styles={{ root: { padding: '10px' }, menuIcon: { fontSize: '16px' } }}
          menuIconProps={{ iconName: 'More' }}
          menuProps={{ items: overflowItems }}
        />
      </TooltipHost>
    );
};

export const __onGetDataGridHtmlContainer = (container) => {
  let _container = JSON.parse(container.htmlContainer)
  
  return _container
}

export const __onRenderMonthContent = (month, shortMonth, longMonth, day) => {
  const fullYear = new Date(day).getFullYear();
  const tooltipText = `Tooltip for month: ${longMonth} ${fullYear}`;

  return <span title={tooltipText}>{shortMonth}</span>;
}

export const CalendarCustomInput = React.forwardRef(({ value, onClick, icon }, ref) => (
  <div className="custom-input" onClick={onClick} ref={ref}>
      <input
          value={value}
          readOnly
          className="date-input"
      />
      {icon}
  </div>
));

export const __calculateTotalRestAdjustmentAmount = (listPolynomy) => {
  // Lo que falta para llegar a 100; los ponderadores se suman como números aunque algunos sean texto.
  return missingPonderador(listPolynomy);
}

export const __GetClientRoleCode = (applicationRoles, appElementTypeId, internalRoleCodeToFind) => {
	try {
		const role = applicationRoles.find(x => x.appElementId === appElementTypeId && x.privlegeRoleCode === internalRoleCodeToFind);
		if (!isNullUndefined(role)) {
			return !isNullUndefinedOrEmpty(role.privlegeRoleClientCode) ? role.privlegeRoleClientCode : internalRoleCodeToFind
		}
		else {
			return internalRoleCodeToFind;
		}
	} catch (error) {
		return internalRoleCodeToFind;
	}
}